import React from 'react';
import { Link } from 'react-router-dom';

const RefundPolicy = () => {
  return (
    <div className="bg-background dark:bg-background min-h-[calc(100vh-64px)] py-10">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="bg-card dark:bg-card p-8 rounded-sm border border-border">
          <h1 className="text-3xl font-bold mb-6 text-foreground dark:text-foreground">Cancellation & Refund Policy</h1>
          <p className="text-muted-foreground mb-6">Last Updated: May 1, 2025</p>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-foreground dark:text-foreground">Subscription Cancellation</h2>
            <p className="mb-4 text-muted-foreground">
              You may cancel your subscription at any time through your account settings or by contacting our customer support team.
            </p>
            <p className="mb-4 text-muted-foreground">
              Upon cancellation:
            </p>
            <ul className="list-disc pl-6 mb-4 text-muted-foreground">
              <li>Your subscription will remain active until the end of your current billing cycle</li>
              <li>You will continue to have access to all features included in your plan until the end of the current billing period</li>
              <li>No further charges will be made to your payment method for future billing cycles</li>
              <li>Your account will automatically downgrade to the free tier at the end of your billing cycle</li>
            </ul>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-foreground dark:text-foreground">Refund Policy</h2>
            <p className="mb-4 text-muted-foreground">
              As a general policy, Testera does not provide refunds for subscription payments already made. When you cancel your subscription:
            </p>
            <ul className="list-disc pl-6 mb-4 text-muted-foreground">
              <li>No refund will be issued for the current billing period</li>
              <li>All recurring charges scheduled for future billing periods will be cancelled</li>
              <li>You will continue to have access to all paid features until the end of the current billing period</li>
            </ul>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-foreground dark:text-foreground">Exceptional Circumstances</h2>
            <p className="mb-4 text-muted-foreground">
              We understand that exceptional circumstances may arise. If you believe your situation warrants special consideration for a refund, please contact our support team at contact@testera.ai with details of your circumstances.
            </p>
            <p className="mb-4 text-muted-foreground">
              Each request will be reviewed on a case-by-case basis. While we cannot guarantee a refund, we are committed to working with our customers to find reasonable solutions when legitimate issues arise.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-foreground dark:text-foreground">Service Disruptions</h2>
            <p className="mb-4 text-muted-foreground">
              In the event of extended service disruptions or technical issues that significantly impact your ability to use our platform, Testera may consider partial refunds or service credits at our discretion.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-foreground dark:text-foreground">Changes to This Policy</h2>
            <p className="mb-4 text-muted-foreground">
              We reserve the right to modify this Cancellation & Refund Policy at any time. Changes will be effective immediately upon posting to our website. We encourage you to periodically review this page for the latest information on our refund policy.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-foreground dark:text-foreground">Contact Us</h2>
            <p className="mb-4 text-muted-foreground">
              If you have questions about our Cancellation & Refund Policy or need assistance with your subscription, please contact us at:
            </p>
            <p className="text-muted-foreground">
              Email: contact@testera.ai<br />
              Phone: +91 9717100100 | +91 9100167640
            </p>
          </section>
          
          <div className="border-t border-border pt-6 mt-8">
            <Link to="/" className="text-secondary hover:text-secondary/90">
              Return to Homepage
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
